import { Validation } from '@shared/lib/utils';

const onPatreonFormValid = (formData) => {
  let errorsState = {};

  const validationEmail = new Validation({
    field: formData.patreonEmail,
    title: 'Patreon email',
  })
    .isRequired()
    .isEmail()
    .maxLenght(64)
    .getErrors();

  if (validationEmail.length) {
    errorsState = {
      ...errorsState,
      patreonEmail: validationEmail[0],
    };
  }

  return errorsState;
};

export default onPatreonFormValid;
